<template>
  <div class="map">
    <div id="allmap" ref="allmap"></div>
    <div
      ref="infoWindowTemplate"
      class="info-window-template"
      v-if="customInfoShow && selectedMarker"
      :style="{
        left: popupPosition.x + 'px',
        top: popupPosition.y + 'px',
        opacity: popupPosition.x ? 1 : 0,
      }"
    >
      <div class="site-title">
        <el-image src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/icon-site.png" style="width: 24px; height: 24px"></el-image>
        <span>{{ selectedMarker.stationName }}</span>
      </div>
      <div class="map-content">
        <div class="info-list">
          <div class="info-item" v-for="(item, i) in dataList" :key="i" :style="{ background: `rgba(${item.color},.1)` }">
            <div class="item-icon">
              <el-image :src="item.icon" style="width: 100%; height: 100%"></el-image>
            </div>
            <div class="item-name">
              {{ item.name }}
            </div>
            <div class="item-value" :style="{ background: `rgb(${item.color})` }">{{ item.value }}{{ item.unit }}</div>
          </div>
        </div>
        <div class="device-list">
          <div class="device-item" v-for="(item, i) in selectedMarker.list" :key="i">
            <div class="item-name">{{ item.sewageBlockName }}：</div>
            <el-image :src="item.statusImage" style="width: 16px; height: 16px"></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, h, nextTick, onMounted, onUnmounted, ref, watch, inject } from "vue";
import { ElMessage, ElMessageBox, ElIcon } from "element-plus";
import markerIcon from "@/assets/img/marker-icon.png";
import errorMarkerIcon from "@/assets/img/map-filling.png";
import { getMapDialogDetail } from "@/api/modules/project";

const receiveTemplateId = inject("templateId");
const onTemplateBigScreenMapClick = inject("onTemplateBigScreenMapClick");
let customInfoShow = ref(false);
let infoWindowTemplate = ref(null);
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
});
const dataList = ref([
  { name: "总功率", value: 0, key: "power", unit: "kw", color: "26, 215, 186", icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/itemIcon4.png" },
  { name: "总用能", value: 0, key: "totalElectric", unit: "kwh", color: "58, 196, 250", icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/itemIcon5.png" },
  { name: "今日用能", value: 0, key: "dayElectric", unit: "kwh", color: "100, 148, 255", icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/itemIcon6.png" },
]);

const selectedMarker = ref(null);
const popupPosition = ref({ x: 0, y: 0 });
// 地图配置**************************************************************************
let map = null;
let markers = ref([]);
const mapAllFun = function (lng, lat) {
  map = new BMap.Map("allmap"); // 创建Map实例
  map.clearOverlays(); // 清除地图上所有覆盖物
  var point = new BMap.Point(lng, lat); // 创建点坐标，汉得公司的经纬度坐标
  map.centerAndZoom(point, 15); //初始化地图,设置中心点坐标，
  map.enableScrollWheelZoom();
  map.addEventListener("moveend", () => {
    customInfoShow.value = false;
  });
};

const getDataList = function () {
  return new Promise((resolve, reject) => {
    let data = props.list;
    clearMarkers();
    data.forEach((item) => {
      addMarker(item);
    });
    setMapViewport();

    resolve(data);
  });
};
const addMarker = function (data) {
  let { longitude, latitude } = data;
  let point = new BMap.Point(longitude, latitude);
  const iconSize = new BMap.Size(34, 47);

  let icon = new BMap.Icon(data.warnNum ? errorMarkerIcon : markerIcon, iconSize, {
    imageSize: iconSize,
  });

  if (data) {
    let marker = new BMap.Marker(point, { icon });

    map.addOverlay(marker);
    marker.customData = data;
    markers.value.push(marker);
    // 调整地图视野，使所有标记点可见
    marker.addEventListener("click", (e) => {
      const clickedMarker = e.target;
      selectedMarker.value = clickedMarker.customData;

      // 获取marker的经纬度
      const point = clickedMarker.getPosition();

      // 将经纬度转换为像素坐标
      const pixel = map.pointToPixel(point);
      customInfoShow.value = true;
      onTemplateBigScreenMapClick(selectedMarker.value.projectId, selectedMarker.value.moduleId);
      // getDetail().then(() => {
      //   calculatePopupPosition(pixel);
      // });
    });
  }
};
// 计算弹窗位置（调整到marker上方）
const calculatePopupPosition = (pixel) => {
  if (!customInfoShow.value) return;
  // 获取弹窗DOM元素计算高度
  nextTick(() => {
    const popupEl = infoWindowTemplate.value;
    if (popupEl) {
      const popupHeight = popupEl.offsetHeight;
      // 位置调整：x居中，y在marker上方（减去弹窗高度和箭头高度）
      popupPosition.value = {
        x: pixel.x - popupEl.offsetWidth / 2, // 水平居中
        y: pixel.y - popupHeight - 40, // 垂直在marker上方（10是箭头高度）
      };
    }
  });
};
// 调整地图视野，显示所有标记点
const setMapViewport = () => {
  if (markers.value.length > 0) {
    const points = markers.value.map((marker) => marker.getPosition());
    map.setViewport(points); // 自动调整视野
  }
};

// 清除所有标记点
const clearMarkers = () => {
  markers.value.forEach((marker) => {
    map.removeOverlay(marker);
  });
  markers.value = [];
};
const getDetail = () => {
  let params = {
    moduleId: selectedMarker.value.moduleId,
    templateId: receiveTemplateId.value,
  };

  return new Promise((resolve, reject) => {
    getMapDialogDetail(params).then((res) => {
      if (res.data.code == 200) {
        dataList.value.forEach((item) => {
          item.value = res.data.data?.sewageStationInfo ? res.data.data.sewageStationInfo[item.key] ?? 0 : 0;
        });
        res.data.data.list.map((item) => {
          item.statusImage = `https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/icon-${item.type.includes("sewageDistributionRoomWaterPump") ? "pump" : "fan"}-status-${
            item.runningState > 0 ? 1 : 0
          }.png`;
        });

        selectedMarker.value = { ...selectedMarker.value, ...res.data.data };
        resolve();
      }
    });
  });
};
watch(
  () => props.list,
  (val) => {
    if (!val) return;
    getDataList();
  },
  { immediate: true, deep: true }
);
onMounted(() => {
  mapAllFun(120.199242, 30.289709);
});
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  #allmap {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-width: 0;
  }
}
.info-window-template {
  position: absolute;
  z-index: 200; /* 确保在地图之上 */
  pointer-events: auto; /* 确保弹窗内按钮可点击 */
  width: 291px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(86, 126, 215, 0.4);
  border-radius: 12px;
  .site-title {
    padding: 8px 16px;
    display: flex;
    align-items: center;
    background-image: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/map-title-bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    span {
      font-weight: bold;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-left: 8px;
    }
  }
  .map-content {
    padding: 16px;
    .info-list {
      display: flex;
      gap: 8px;
      .info-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        overflow: hidden;
        .item-icon {
          margin-top: 5px;
          width: 26px;
          height: 26px;
        }
        .item-name {
          font-size: 8px;
          color: #666666;
          padding: 2px 0;
        }
        .item-value {
          font-weight: 600;
          font-size: 12px;
          color: #ffffff;
          line-height: 16px;
          padding: 5px 0;
          width: 100%;
          text-align: center;
        }
      }
    }
    .device-list {
      margin-top: 24px;
      display: flex;
      gap: 24px 10px;
      flex-wrap: wrap;
      .device-item {
        width: calc(50% - 10px);
        display: flex;
        align-items: center;
        .item.name {
          font-weight: bold;
          font-size: 12px;
          color: #333333;
          line-height: 12px;
        }
      }
    }
  }
}

/* 深度选择器 - 强制覆盖百度地图样式 */
::v-deep .BMap_bubble_content {
  padding: 0 !important;
  overflow: visible !important;
}

::v-deep .BMap_pop {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  > div,
  > img:nth-child(10) {
    display: none;
    overflow: unset;
  }
  > div:nth-child(9) {
    display: block;
    overflow: unset;
    width: 340px !important;
  }
  > div:nth-child(8) {
    /*display: block;*/
  }
  .BMap_top {
    display: none;
  }
  .BMap_center {
    background: transparent;
    border: none;
    position: sticky !important;
    height: 100%;
  }
}

::v-deep .BMap_top,
::v-deep .BMap_bottom {
  display: none !important;
}

::v-deep .BMap_center {
  background: transparent !important;
  border: none !important;
}
</style>
